<template>
  <div>
    <Card v-if="!isVerifiedIdentity">
      <div class="QRcodeBox">
        <Spin size="large" fix v-if="loading"></Spin>
        <p>
          <img src="../../assets/images/weixin.png" class="QRtitle">
          <span class="QRspan">请使用微信扫码核验身份</span>
        </p>
        <div class="al">
          身份核验成功后查看调档函
        </div>
        <!-- <div v-if="form.personnelId" class="personnelInfo">
          <div v-if="form.personnelId"><span>
              <Icon type="ios-person" size="20" />人事姓名：
            </span>{{form.personnelName}}</div>
          <div v-if="form.personnelId"><span>
              <Icon type="ios-card" size="20" />身份证：
            </span>{{form.personnelIDCardNo}}</div>
        </div> -->
        <div class="QRcode">
          <img :src="'data:image/png;base64,'+QRcode" alt="">
        </div>
      </div>
    </Card>
    <div>
      <DownDetail v-if="isVerifiedIdentity"></DownDetail>
    </div>
  </div>

</template>
<script>
import DownDetail from './downDetail.vue'
import '../residencePermitIntegral/styles/points.less'
export default {
  components: {
    DownDetail,
  },
  created() {
    // if (
    //   localStorage.getItem('isVerifiedIdentity') == 'true' ||
    //   localStorage.getItem('isVerifiedIdentity') === true
    // ) {
    //   this.isVerifiedIdentity = true
    // } else {
    //   this.isVerifiedIdentity = false
    //   this.checkUserOpen()
    // }
  },
  mounted() {
    this.init()
  },
  data() {
    return {
      isVerifiedIdentity: null, //人脸核验是否通过
      loading: false,
      QRcode: '', //人脸核验二维码
      timer: null, //定时器
      key: null, //
      tableData: {},
    }
  },
  methods: {
    async init() {
      this.loading = true
      try {
        let { data } = await this.$Ajax.post(
          '/api/services/app/TSRCDDHApi/GetCurrentSpecialTalentDDH'
        )
        console.log('🚀 ~ getData ~ data:', data)
        this.tableData = data.result
        this.isVerifiedIdentity = data.result.isVerifiedIdentity //是否通过
        if (this.isVerifiedIdentity === false) {
          this.checkUserOpen()
        }
      } catch (error) {
        this.$Modal.error({
          title: '提示',
          content: '出错了',
        })
      }
      this.loading = false
    },

    //关闭核验经办人弹窗
    colseQR() {
      clearTimeout(this.timer)
      this.timer = null
    },

    // 打开核验经办人弹窗获取二维码
    async checkUserOpen() {
      this.loading = true

      this.key = this.tableData.id + '|' + new Date().getTime()
      let { data } = await this.$Ajax.post('/api/services/app/TSRCDDHApi/GetIdentityCheckQrcode', {
        key: this.key,
      })
      this.QRcode = data.result.imgBase64String
      this.loading = false
      if (this.isVerifiedIdentity === false) {
        this.checkUser(data.result.contextId)
      }
    },
    // 核验经办人 获取个人信息轮询
    checkUser(key) {
      let _this = this
      const poll = async () => {
        let { data } = await this.$Ajax.post(
          `/api/services/app/TSRCDDHApi/GetIdentityCheckResult`,
          {
            key,
          }
        )
        if (data.result.success) {
          _this.colseQR()
          try {
            _this.isVerifiedIdentity = true
            // localStorage.setItem('isVerifiedIdentity', 'true')
          } catch (error) {
            _this.$Message.error({
              content: '操作失败',
              background: true,
              duration: 6,
            })
          }
        } else {
          _this.timer = setTimeout(poll, 2500)
        }
      }
      poll()
    },
  },

  destroyed() {
    this.colseQR()
  },
}
</script>
<style lang="less" scoped>
// .QRcodeBox {
//   width: 100%;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
// }
p {
  text-align: center;
  margin-top: 20px;
}
.QRtitle {
  width: 24px !important;
}
.QRspan {
  font-size: 22px !important;
}
.QRcode {
  margin: 20px 0px 40px 0px;
}
.al {
  display: flex;
  justify-content: center;
  color: #ff9900;
}
</style>